/**
 * 트레이너 포털 전용 Supabase 쿼리
 */
import { supabase } from './supabase';
import { toCamel } from '../utils/helpers';

// 내 트레이너 레코드 (trainers.user_id = auth.uid())
export async function getMyTrainerRecord() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  const { data, error } = await supabase
    .from('trainers')
    .select('*')
    .eq('user_id', user.id)
    .maybeSingle();
  if (error) return null;
  return toCamel(data);
}

// 헬스장 정보
export async function getTrainerGym(gymId) {
  const { data, error } = await supabase
    .from('gyms')
    .select('id, name, phone, address, code')
    .eq('id', gymId)
    .single();
  if (error) return null;
  return toCamel(data);
}

// 내 PT 배정 목록 (활성)
export async function getTrainerPtAssignments(trainerId) {
  const { data, error } = await supabase
    .from('pt_assignments')
    .select('*')
    .eq('trainer_id', trainerId)
    .eq('status', 'active')
    .order('created_at', { ascending: false });
  if (error) return [];
  return (data || []).map(toCamel);
}

// 내 PT 배정 목록 (완료)
export async function getTrainerCompletedPtAssignments(trainerId) {
  const { data, error } = await supabase
    .from('pt_assignments')
    .select('*')
    .eq('trainer_id', trainerId)
    .eq('status', 'completed')
    .order('created_at', { ascending: false });
  if (error) return [];
  return (data || []).map(toCamel);
}

// 내 헬스장 회원 목록 (이름/프로필 표시용)
export async function getTrainerMembers(gymId) {
  const { data, error } = await supabase
    .from('members')
    .select('id, name, phone, photo, gender')
    .eq('gym_id', gymId)
    .in('status', ['active', 'pending']);
  if (error) return [];
  return (data || []).map(toCamel);
}

// PT 일지 목록 (해당 트레이너)
export async function getTrainerPtLogs(trainerId) {
  const { data, error } = await supabase
    .from('pt_logs')
    .select('*')
    .eq('trainer_id', trainerId)
    .order('date', { ascending: false });
  if (error) return [];
  return (data || []).map(toCamel);
}

// PT 수업 기록 (RPC)
export async function trainerAddPtLog({ assignmentId, date, content, memo }) {
  const { error } = await supabase.rpc('trainer_add_pt_log', {
    p_assignment_id: assignmentId,
    p_date: date,
    p_content: content,
    p_memo: memo || null,
  });
  return { error };
}

// PT 일지 수정
export async function trainerUpdatePtLog(logId, { content, memo }) {
  const patch = {};
  if (content !== undefined) patch.content = content;
  if (memo !== undefined) patch.memo = memo;
  const { error } = await supabase.from('pt_logs').update(patch).eq('id', logId);
  return { error };
}

// PT 일지 삭제
export async function trainerDeletePtLog(logId) {
  const { error } = await supabase.from('pt_logs').delete().eq('id', logId);
  return { error };
}

// 사업자등록증 업로드
const ALLOWED_DOC_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
export async function uploadBusinessDoc(file) {
  if (!ALLOWED_DOC_TYPES.includes(file.type)) {
    return { error: '허용되지 않는 파일 형식입니다. JPG, PNG, PDF만 업로드 가능합니다.' };
  }
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  const ext = file.name.split('.').pop().toLowerCase();
  const path = `${user.id}/business-doc.${ext}`;
  const { error } = await supabase.storage
    .from('business-docs')
    .upload(path, file, { upsert: true, contentType: file.type });
  if (error) return null;
  return path;
}

// 사업자등록증 URL 업데이트
export async function updateBusinessDocUrl(url) {
  const { error } = await supabase.rpc('update_owner_profile', {
    p_business_doc_url: url,
  });
  return { error };
}
